module.exports = __webpack_public_path__ + "static/media/stockhausen_dortineinemanderen_2.713a5454.jpeg";